"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCategories = void 0;
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
const useCategories = ()=>{
    const { tenant } = (0, _environment.useEnvironment)();
    const { data, error } = (0, _globalApiClientReact.useGetApplicationsSupportCenterCategories)({
        [_fetching.TENANT_CONTEXT]: tenant
    });
    const loading = data === undefined && error === undefined;
    return {
        data,
        loading
    };
};
exports.useCategories = useCategories;
